import React, { Suspense } from "react";
import { withNamespaces } from "react-i18next";
import { Tab } from "semantic-ui-react";
const Fields = React.lazy(() => import("./components/Fields"));
const Filters = React.lazy(() => import("./components/Filters"));
const Order = React.lazy(() => import("./components/Order"));
const Preview = React.lazy(() => import("./components/Preview"));

function ReportPreview(props) {
  const tabs = [
    {
      menuItem: props.t("fields"),
      render: () => (
        <Suspense fallback={<div>Loading...</div>}>
          {" "}
          <Fields action={props.action} reportId={props.reportId} userId={props.userId} rolId={props.rolId} />
        </Suspense>
      ),
    },
    {
      menuItem: props.t("filters"),
      render: () => (
        <Suspense fallback={<div>Loading...</div>}>
          {" "}
          <Filters />
        </Suspense>
      ),
    },
    {
      menuItem: props.t("ordering"),
      render: () => (
        <Suspense fallback={<div>Loading...</div>}>
          {" "}
          <Order />
        </Suspense>
      ),
    },
    {
      menuItem: props.t("previsualization"),
      render: () => (
        <Suspense fallback={<div>Loading...</div>}>
          {" "}
          <Preview />
        </Suspense>
      ),
    },
  ];

  return (
    // <div className='col-md-12 mt-5'>
    <Tab
      menu={{ secondary: true, pointing: true, className: "custom-tab-menu" }}
      menuPosition={"right"}
      panes={tabs}
    />
    // </div>
  );
}

export default withNamespaces()(ReportPreview);
